import modulePaths from 'constants/modulePath';
import moduleCodes from 'constants/moduleCodes';
import routePath from 'constants/routePath';
import queryString from 'query-string';
import { isNil } from 'lodash';
const modulePath = modulePaths[moduleCodes.MODULE_INSPECTION_COACH];

const getters = {
  getModuleUrl: () => `/${modulePath}`,
  getTopicUrl: (questionnaireId, topicId, tabCode, questionId) => {
    const base = `/${modulePath}/questionnaires/${questionnaireId}/topics/${topicId}`;
    const query = queryString.stringify({
      tab: tabCode,
      question: questionId
    });

    return `${base}?${query}`;
  },
  getHomeUrl: (selectedQuestionnaireId) => {
    const base = `/${modulePath}/${routePath.ROUTE_INSPECTION_COACH_HOME}`;
    const query = queryString.stringify({questionnaire: selectedQuestionnaireId});

    return `${base}?${query}`;
  },
  getSelfEvaluation: (questionnaireId) => {
    const base = `/${modulePath}/self-evaluation/`;
    const query = isNil(questionnaireId) ? '' : queryString.stringify({questionnaire: questionnaireId});
    return `${base}?${query}`;
  },
  getProfileUrl: () => `/${modulePath}/${routePath.ROUTE_MY_PROFILE}`
};

export default getters;
